import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import {
  getComparator,
  getCurrentListInfo,
  getRankingTimes,
  getUser,
  isRumbleComplete,
  isUserReady,
} from '../redux/selectors';
import RankedItem from '../components/RankedItem/RankedItem';
import { getCookieValue } from '../logic/Helpers';
import PageHeader from '../components/PageHeader/PageHeader';
import QrCodeWithDownload from '../components/QrCodeWithDownload';
import Label from '../components/Label/Label';
import ShareCopyDoneIcon from '../components/Icons/ShareCopyDoneIcon';
import ShareCopyIcon from '../components/Icons/ShareCopyIcon';
import CustomModal from '../components/CustomModal/CustomModal';
import Button from '../components/Button/Button';
import Input from '../components/Input/Input';
import clsx from 'clsx';

function ListPage(props) {
  const [responseId, setResponseId] = useState(0);
  const [inError, setInError] = useState(false);
  const search = location.search;
  const participantId = new URLSearchParams(search).get('user');
  const [isShareOpen, setIsShareOpen] = useState(false);
  const [isCopied, setIsCopied] = useState(false);
  const [shareLink, setShareLink] = useState('');
  const history = useHistory();
  function copyListLink() {
    let copyButton = document.getElementById('copyButton');
    let listLink = document.getElementById('listLink');
    setIsCopied(true);
    listLink.disabled = false;
    listLink.focus();
    listLink.select();
    listLink.setSelectionRange(0, 9999);
    document.execCommand('copy');
    listLink.disabled = true;
    listLink.setSelectionRange(0, 0);
    listLink.blur();
    copyButton.disabled = true;
    setTimeout(resetCopyButton, 2000);
  }

  function resetCopyButton() {
    let copyButton = document.getElementById('copyButton');
    copyButton.disabled = false;
    setIsCopied(false);
  }

  function closeShareModal() {
    setIsShareOpen(false);
  }

  useEffect(() => {
    if (props.currentList === null) {
      history.push('/');
      return;
    }
    if (!props.isRumbleComplete || !props.comparator) {
      history.push('/');
    }

    let rankedItems = props.comparator.toList();
    let rankingTimes = props.rankingTimes;
    let saveData = {
      rankingTimes,
      rankedItems,
    };
    if (participantId) {
      saveData.participantId = participantId;
    }

    let completed = null;
    if (typeof Storage !== 'undefined') {
      completed = localStorage.getItem('completedLists');
    }
    let completedIds = [];
    if (completed) {
      completedIds = completed.split(',').map(parseInt);
    }

    if (completedIds.includes(props.currentList.id)) {
      let responseIds = null;
      if (typeof Storage !== 'undefined') {
        responseIds = localStorage.getItem('responseIds');
      }
      if (responseIds) {
        const responseIdsMap = JSON.parse(responseIds);
        if (props.currentList.id in responseIdsMap) {
          setResponseId(responseIdsMap[props.currentList.id]);
        }
      }
      return;
    }

    const xsrfToken = getCookieValue('XSRF-TOKEN');

    fetch(`/api/RumbleLists/SaveResults/${props.currentList.id}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-XSRF-TOKEN': xsrfToken,
      },
      body: JSON.stringify(saveData),
    })
      .then((res) => {
        if (res.ok && typeof Storage !== 'undefined') {
          let completed = localStorage.getItem('completedLists');
          let completedIds = [];
          if (completed) {
            completedIds = completed.split(',');
          }
          completedIds.push(props.currentList.id);
          localStorage.setItem('completedLists', completedIds.join(','));
        }
        return res.json();
      })
      .then((json) => {
        let responseIds = null;
        if (typeof Storage !== 'undefined') {
          responseIds = localStorage.getItem('responseIds');
        }
        let responseIdsMap = {};
        if (responseIds) {
          responseIdsMap = JSON.parse(responseIds);
        }
        responseIdsMap[props.currentList.id] = json;
        localStorage.setItem('responseIds', JSON.stringify(responseIdsMap));
        setResponseId(json);
        setShareLink(
          `${process.env['REACT_APP_BASE_URL']}/share/${props.currentList.id}/${json}`
        );
      })
      .catch((e) => setInError(true));
  }, [props.comparator, history, props.isRumbleComplete, props.currentList]);

  if (inError) {
    return (
      <div className='container text-center h-full'>
        <div
          className={'h-full flex flex-col gap-4 items-center justify-center'}
        >
          <header className={'mb-4'}>
            <Link to='/' className={'inline'}>
              <img
                src={
                  props.currentList?.whiteLabelInfo?.imageURL ||
                  'img/rr-logo.png'
                }
                alt={
                  props.currentList?.whiteLabelInfo?.imageURL
                    ? `${props.currentList.authorCompany} logo`
                    : 'RumbleRank Logo'
                }
                className={'inline'}
                width={'124'}
                height={'96'}
              />
            </Link>
          </header>
          <h1>An error occurred when submitting your results</h1>
          <p>Try ranking the list again</p>
          <Button
            tag={'Link'}
            to={`/Share/${props.currentList.id}`}
            variant={'primary'}
          >
            Rank list again
          </Button>
        </div>
      </div>
    );
  }

  if (!props.comparator || !responseId) {
    return null;
  }
  return (
    <>
      {props.user && props.ready && (
        <PageHeader
          props={props}
          title={`Here are your results for ${props.currentList.name}`}
          logOutModal={props.logOutModal}
          editModal={props.editModal}
          isEditOpen={props.isEditOpen}
          isFullOpen={props.isFullOpen}
        />
      )}
      <div
        className={clsx(
          props.user && props.ready ? 'tablet:pt-32' : null,
          !props.user && props.ready ? 'pt-10' : null
        )}
      >
        <div className={'container'}>
          {!props.user && props.ready && (
            <div className={'text-center'}>
              <header className={'mb-8'}>
                <Link to='/' className={'inline'}>
                  <img
                    src={
                      props.currentList?.whiteLabelInfo?.imageURL ||
                      'img/rr-logo.png'
                    }
                    alt={
                      props.currentList?.whiteLabelInfo?.imageURL
                        ? `${props.currentList.authorCompany} logo`
                        : 'RumbleRank Logo'
                    }
                    className={'inline'}
                    width={'124'}
                    height={'96'}
                  />
                </Link>
              </header>
              <h1
                className={'mb-8'}
              >{`Here are your results for ${props.currentList.name}`}</h1>
            </div>
          )}
          <div className={'max-w-[600px] mx-auto flex flex-col gap-4'}>
            <div className={'flex flex-col gap-3'}>
              {props.comparator.toList().map((i) => {
                return (
                  <RankedItem
                    key={i.id}
                    id={i.id}
                    name={i.name}
                    description={i.description}
                    imageURL={i.imageURL}
                    wins={i.wins}
                    score={i.aggregatedPlaces}
                    showScore={false}
                  />
                );
              })}
            </div>
            <Button variant={'primary'} onClick={() => setIsShareOpen(true)}>
              Share Results
            </Button>
            {props.ready && !props.user ? (
              <p className={'text-20 text-center'}>
                Want to create your own Rumbles?{' '}
                <a className={'font-semibold text-blue'} href={'/Login'}>
                  Sign up for free.
                </a>
              </p>
            ) : null}
          </div>
          <CustomModal
            isOpen={isShareOpen}
            isClose={closeShareModal}
            variant={'share'}
          >
            <div className={'flex flex-col gap-4'}>
              <p className={'text-primary text-16 leading-150 font-semibold'}>
                Share your results
              </p>
              <div>
                <Label
                  htmlFor={'listLink'}
                  text={'Link to share your results:'}
                />
                <div className={'relative'}>
                  <Input
                    id={'listLink'}
                    variant={'text'}
                    value={shareLink}
                    className={'pr-11'}
                    disabled
                  />
                  <button
                    className={
                      'absolute right-0 h-full top-0 flex items-center justify-center px-3'
                    }
                    type={'button'}
                    id={'copyButton'}
                    onClick={copyListLink}
                  >
                    {isCopied ? <ShareCopyDoneIcon /> : <ShareCopyIcon />}
                  </button>
                </div>
              </div>
              <QrCodeWithDownload
                content={shareLink}
                fileName={`RumbleRank_${props.currentList.name.replace(
                  /[^\w]/g,
                  '_'
                )}_QR.png`}
                close={closeShareModal}
              />
            </div>
          </CustomModal>
        </div>
      </div>
    </>
  );
}

function mapStateToProps(state) {
  return {
    user: getUser(state),
    ready: isUserReady(state),
    isRumbleComplete: isRumbleComplete(state),
    currentList: getCurrentListInfo(state),
    comparator: getComparator(state),
    rankingTimes: getRankingTimes(state),
  };
}

export default connect(mapStateToProps, {})(ListPage);
